export const iconFontAwesomeDevicesHardwareMobileScreen = (
	<i className="fa-solid fa-mobile-screen"></i>
);
